import { IController } from 'angular';
import * as _ from 'lodash';
import { CurrentSchoolYear } from '../../../../../../../../../../ng2/shared/constants/current-school-year.constant';
import { WizardUtils } from '../../../../../../../../../shared/services/wizard-utils/wizard-utils.service';
// tslint:disable:max-line-length
import { RegentsPrepPriorityGroupingsTransferService } from './../../../../../../../../../shared/services/regents-prep-priority-groupings/regents-prep-priority-groupings-transfer.service';

export class StudentReviewTransferCtrl implements IController {
  public filteredStudents;
  public organizedPriorityData;
  public totalStudents;
  public totalExams;
  public graduatingCohort;
  public options;

  static $inject = ['$scope', 'ObjectCache', '$state', 'WizardUtils', 'RegentsPrepPriorityGroupingsTransferService'];

  constructor(
    public $scope,
    private ObjectCache,
    private $state,
    private WizardUtils: WizardUtils,
    private RegentsPrepPriorityGroupingsTransferService: RegentsPrepPriorityGroupingsTransferService,
  ) {
    //
  }

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi() {
    this.filteredStudents = this.WizardUtils.getFilteredFlattenedStudents();
    this.organizedPriorityData = this.organizeStudentsByPriority(this.filteredStudents);
    this.totalStudents = this.getTotalStudents(this.organizedPriorityData);
    this.totalExams = this.getTotalExams(this.organizedPriorityData);
    this.graduatingCohort = Number(CurrentSchoolYear.ENDFULL);
    this.options = {
      columnKeys: ['cohort', 'gradPlan', 'regentsSchedNextAdminWithNoPrep'],
    };
  }

  goToStudentProfile = studentIds => {
    const filter = this.ObjectCache.cacheObject({ studentId: studentIds });
    this.$state.go(`main.school.new-sdc.regents-prep.profile`, { filter });
  };

  private getTotalStudents = priorityGroups => {
    return _.reduce(
      priorityGroups,
      (result, priorityGroup: any) => {
        result = result.concat(priorityGroup.studentIds);
        return result;
      },
      [],
    );
  };

  private getTotalExams = priorityGroups => {
    return _.reduce(
      priorityGroups,
      (result, priorityGroup: any) => {
        result += priorityGroup.examCount;
        return result;
      },
      0,
    );
  };

  private organizeStudentsByPriority = students => {
    const regentsPrepPriorityGroups = this.RegentsPrepPriorityGroupingsTransferService.getPriorityGroupsByPlannedGradDateFilter().map(
      x => x.studentPriorityGroupingValue,
    );

    const priorityGroups = _.reduce(
      regentsPrepPriorityGroups,
      (priorityGroups: any, group, i) => {
        if (i >= 7) return priorityGroups;
        priorityGroups[++i] = { studentIds: [], examCount: 0, text: regentsPrepPriorityGroups[--i] };
        return priorityGroups;
      },
      {},
    );

    _.each(students, (student: any) => {
      const { studentId, regentsPrepPriorityGrouping, countOfRegentsSchedNextAdminWithNoPrep } = student;
      if (regentsPrepPriorityGrouping === regentsPrepPriorityGroups[0]) {
        priorityGroups[1].studentIds.push(studentId);
        priorityGroups[1].examCount += countOfRegentsSchedNextAdminWithNoPrep;
      } else if (regentsPrepPriorityGrouping === regentsPrepPriorityGroups[1]) {
        priorityGroups[2].studentIds.push(studentId);
        priorityGroups[2].examCount += countOfRegentsSchedNextAdminWithNoPrep;
      } else if (regentsPrepPriorityGrouping === regentsPrepPriorityGroups[2]) {
        priorityGroups[3].studentIds.push(studentId);
        priorityGroups[3].examCount += countOfRegentsSchedNextAdminWithNoPrep;
      } else if (regentsPrepPriorityGrouping === regentsPrepPriorityGroups[3]) {
        priorityGroups[4].studentIds.push(studentId);
        priorityGroups[4].examCount += countOfRegentsSchedNextAdminWithNoPrep;
      } else if (regentsPrepPriorityGrouping === regentsPrepPriorityGroups[4]) {
        priorityGroups[5].studentIds.push(studentId);
        priorityGroups[5].examCount += countOfRegentsSchedNextAdminWithNoPrep;
      } else if (regentsPrepPriorityGrouping === regentsPrepPriorityGroups[5]) {
        priorityGroups[6].studentIds.push(studentId);
        priorityGroups[6].examCount += countOfRegentsSchedNextAdminWithNoPrep;
      } else if (regentsPrepPriorityGrouping === regentsPrepPriorityGroups[6]) {
        priorityGroups[7].studentIds.push(studentId);
        priorityGroups[7].examCount += countOfRegentsSchedNextAdminWithNoPrep;
      }
    });
    return priorityGroups;
  };
}
